var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTranslate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "48.1556mm",
    height: "43.9193mm",
    viewBox: "0 0 4763.35 4344.31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M379.75 3419.86l227.58 227.58 1117.76 -1117.77 44.75 44.81 625.51 625.52 121.21 -325.3 -584.02 -577.11 50.55 -50.51c371.9,-415.03 649.62,-902.66 814.86,-1434.97l13.84 -44.55 638.32 0 0 -320.45 -1564.82 0 0 -447.1 -320.45 0 0 447.1 -1564.84 0 0 320.45 2522.89 0 -29.41 84.2c-157,449.52 -402.67,863.74 -721.37,1217.5l-46.99 52.17 -47.05 -52.13c-198.98,-220.43 -369.58,-465.27 -507.85,-727.99l-309.47 0c159.51,332.3 367.64,639.52 614.1,913.73l40.43 44.97 -43.06 42.43 -1092.46 1077.44zm4071.7 924.46l311.9 0 -958.48 -2555.93 -359.31 0 -958.49 2555.93 311.78 0 238.21 -638.08 12.24 -32.57 1149.52 0 15.48 40.99 237.16 629.66zm-1279.73 -991.11l406.43 -1086.2 47.04 -125.89 59.33 158.64 362.18 967.99 31.87 85.46 -906.85 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTranslate);
export default __webpack_public_path__ + "static/media/translate.d3bd7371e6ac95cd82bc74c833100a52.svg";
export { ForwardRef as ReactComponent };